/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// theme.js has hardcoded getElementById/querySelector calls for
// '#shopify-section-header' - the wrapper Shopify generated when header was a
// static section. Now that header is inside header-group the wrapper ID is
// different. This shim intercepts those two DOM APIs and resolves to the actual
// header wrapper at call time, so z-index, transforms, and --header-height
// all work correctly on the real element.
(function () {
  var _getElementById = Document.prototype.getElementById.bind(document);
  var _querySelector  = Document.prototype.querySelector.bind(document);

  function resolveHeaderSection() {
    // Find the header element by its section type attribute (hardcoded in header.liquid)
    var headerEl = _querySelector('[data-section-type="header"]')
      || _querySelector('#section-header')
      || _querySelector('.Header[data-section-id]');
    if (!headerEl) return null;

    // Prefer the direct parent if it looks like a shopify-section wrapper
    var parent = headerEl.parentElement;
    if (parent && parent.id && parent.id.startsWith('shopify-section')) {
      return parent;
    }

    // Fallback: nearest ancestor with a shopify-section* id
    var wrapper = headerEl.closest('[id^="shopify-section"]');
    return wrapper || headerEl;
  }

  document.getElementById = function (id) {
    if (id === 'shopify-section-header') {
      return resolveHeaderSection() || _getElementById(id);
    }
    return _getElementById(id);
  };

  document.querySelector = function (selector) {
    if (selector === '#shopify-section-header') {
      return resolveHeaderSection() || _querySelector(selector);
    }
    return _querySelector(selector);
  };
})();

const reset_selected_swatches = (swatchList) => {
  swatchList.forEach((swatch) => {
    swatch.classList.remove('color-swatch--selected');
  });
};

const update_swatch_img = () => {
  if (window.b2b) return;
  let cards = document.querySelectorAll('.Grid__Cell .ProductItem');
  if (cards.length > 0) {
    cards.forEach((card) => {
      let img_swatches = card.querySelectorAll('.color-options a');
      img_swatches.forEach((swatch) => {
        let img_url = swatch.querySelector('img').getAttribute('data-feat-img');
        let img_url_alt = swatch.querySelector('img').getAttribute('data-feat-img-alt');
        let pre_load = (new Image().src = img_url);
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          reset_selected_swatches(img_swatches);
          let card_img = card.querySelector('img.ProductItem__Image');
          card_img.srcset = '';
          card_img.src = img_url;
          card_img.setAttribute('data-current-src', img_url);
          card_img.setAttribute('data-alt-img-hover', img_url_alt);
          swatch.classList.add('color-swatch--selected');
          add_image_hover(card);
        });
      });
    });
  }
};
update_swatch_img();

const add_image_hover = (single = false) => {
  if (window.b2b) return;
  let prod_cards = document.querySelectorAll('.Grid__Cell .ProductItem');
  if (!prod_cards) {
    console.log('!! no cards');
    return;
  }

  if (!single) {
    prod_cards.forEach((card) => {
      let card_img = card.querySelector('img.ProductItem__Image');
      let current_img = card_img.getAttribute('data-current-src');
      let alt_src = card_img.getAttribute('data-alt-img-hover');
      let pre_load = (new Image().src = alt_src);

      card_img.addEventListener('mouseenter', (e) => {
        alt_src = card_img.getAttribute('data-alt-img-hover');
        card_img.srcset = '';
        card_img.src = alt_src;
      });
      card_img.addEventListener('mouseleave', (e) => {
        current_img = card_img.getAttribute('data-current-src');
        card_img.src = current_img;
      });
    });
  } else {
    let card_img = single.querySelector('img.ProductItem__Image');
    let current_img = card_img.getAttribute('data-current-src');
    let alt_src = card_img.getAttribute('data-alt-img-hover');
    let pre_load = (new Image().src = alt_src);

    card_img.addEventListener('mouseenter', (e) => {
      alt_src = card_img.getAttribute('data-alt-img-hover');
      card_img.srcset = '';
      card_img.src = alt_src;
    });
    card_img.addEventListener('mouseleave', (e) => {
      current_img = card_img.getAttribute('data-current-src');
      card_img.src = current_img;
    });
  }
};
add_image_hover();

window.quickAddToCart = async function (variantID, qty = 1) {
  if (!variantID) return;
  try {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const url = `${window.Shopify.routes.root}cart/add.js`;
    const data = {
      items: [
        {
          id: variantID,
          quantity: qty,
        },
      ],
    };
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(data),
    };

    const response = await fetch(url, config);
    const result = await response.json();
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if (response.ok) {
      document.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variantID,
            quantity: qty,
          },
        }),
      );
    } else {
      console.error(result.message);
    }
  } catch (error) {
    console.error(err);
  }
};

function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if (timeout) {
      setTimeout(() => {
        observer.disconnect();
      }, timeout);
    }
  });
}

async function scrollToYotpoReviews() {
  const el = await waitForElement('.yotpo.bottomLine.yotpo-small');
  if (!el) return;
  el.addEventListener('click', async () => {
    try {
      const recommendations = await waitForElement('.ss__recommendation--target', 1500);
      if (recommendations) scrollToReviews();
    } catch {
      scrollToReviews();
    }
  });
}

function scrollToReviews() {
  const target = document.querySelector('.yotpo-widget-instance[data-yotpo-product-id]');
  if (!target) return;

  const headerOffset = 140;

  const targetTop = target.getBoundingClientRect().top + window.scrollY;
  const scrollPosition = targetTop - headerOffset;

  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth',
  });
}

function stickyAtc() {
  if (window.innerWidth > 580) return;
  const storeHeaderHeight = document.querySelector('[data-section-id="header"]')?.clientHeight || 0;
  const anchor = document.querySelector('[data-mobile-atc-button]');
  const stickyButton = document.querySelector('[data-desktop-atc-button]');
  if (!anchor || !stickyButton) return;
  const anchorBottom = anchor.getBoundingClientRect().bottom;
  stickyButton.classList.toggle('active', anchorBottom < storeHeaderHeight);
  console.log('test');
}

stickyAtc();

document.addEventListener('scroll', () => {
  stickyAtc();
});

document.addEventListener('DOMContentLoaded', async () => await scrollToYotpoReviews());

document.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type == 'submit') {
    window.scrollTo({
      top: document.querySelector('.klaviyo-form').offsetTop - 100,
      behavior: 'instant',
    });
  }
});
